import React from 'react';
import cx from 'classnames';

import Fab from '@material-ui/core/Fab';
import Chip from '@material-ui/core/Chip';

import Tree from '../../tree/Index';
import { AddIcon } from '../../../images/icons/WrapSvg';
import DialogRoleSelect from './DialogRoleSelect';

const flatNodes = (node) => {
    let result = [node];
    if (node.children) {
        node.children.forEach((c) => (result = result.concat(flatNodes(c))));
    }
    return result;
};

const reviewComplete = (node, arr) => {
    const toReview = flatNodes(node);
    let result = true;

    if (toReview && toReview.length > 0) {
        const index = arr.map((i) => i.id);
        toReview.forEach((r) => {
            result = result && index.indexOf(r.id) >= 0;
        });
    }

    return result;
};

const getTopNodes = (arr) => {

    return arr.reduce((list, i) => {
        if (!list.some(v => i.path.indexOf(v.path) >= 0)) {
            list.push(i);
        }
        return list;
    }, []);

}

class RoleTree extends React.Component {

    state = {
        tree: this.props.tree,
        value: this.props.value,
        openDialog: false,
        selected: undefined,
        active: [],
    };

    static getDerivedStateFromProps(props, state) {
        const { tree, value } = props;
        if (tree !== state.tree || value !== state.value) {
            //console.log('getDerivedStateFromProps');
            state.tree = tree;
            state.value = value;
            return state;
        }
        return null;
    }

    sortedTree = (tree) => {
        const hijos = [...tree.children]
            .sort((a, b) => (a.name > b.name ? 1 : -1))
            .map((c) => this.sortedTree(c));
        tree.children = hijos;
        return tree;
    };

    handleClickOpenDialog = (event) => {
        this.setState({ openDialog: true });
    };

    handleDelete = (nodeId, roleId) => () => {

        const arr = [...this.state.value];
        const news = arr.filter((f) => !(f.idLocal && f.idRol && f.idLocal.toString() === nodeId.toString() && f.idRol.toString() === roleId.toString()));
        this.props.handleUpdate('selectedroleslocals', news);
        this.setState({ value: news });

    };

    handleChangeRoles = (values) => {
        if (values) {
            const { active, value } = this.state;

            const topNodes = getTopNodes(active);

            let temp = value.concat(
                values.reduce(
                    (arr, item) => {
                        arr = arr.concat(
                            topNodes.map((n) => { return { idLocal: n.id, idRol: item.id } })
                        )
                        return arr;
                    }, [])
            );

            this.props.handleUpdate('selectedroleslocals', temp);
            this.setState({ openDialog: false, active: [], value: temp });

        } else {
            this.setState({ openDialog: false, });
        }

    }

    onClickNode = (node) => {

        let nodes = flatNodes(node);
        if (
            node &&
            this.state.active &&
            this.state.active.map((c) => c.id).indexOf(node.id) >= 0
        ) {
            const toRemove = nodes;
            if (toRemove && toRemove.length > 0) {
                nodes = this.state.active;
                toRemove.forEach((r) => {
                    const index = nodes.map((i) => i.id).indexOf(r.id);
                    if (index >= 0) {
                        nodes.splice(index, 1);
                    }
                });
            }
        } else {
            const aux = this.state.active;
            nodes.forEach((r) => {
                const index = aux.map((i) => i.id).indexOf(r.id);
                if (index < 0) {
                    aux.push(r);
                }
            });
            nodes = aux;
        }

        if (nodes && nodes.length > 0) {
            [...nodes]
                .sort((a, b) => (a.path > b.path ? -1 : 1))
                .forEach((n) => {
                    if (!reviewComplete(n, nodes)) {
                        const toRemoveIndex = nodes.map((i) => i.id).indexOf(n.id);
                        nodes.splice(toRemoveIndex, 1);
                    }
                });
        }

        this.setState({
            active: nodes,
        });

    };

    renderNode = (values) => (node) => {

        const element = values ? values.filter((f) => parseInt(f.idLocal, 10) === parseInt(node.id, 10)) : [];
        const listRoles = element.reduce((arr, i) => {
            if (!arr.find((r) => r.id.toString() === i.idRol.toString())) {
                arr.push(this.props.suggestions.find((s) => s.id && i.idRol && s.id.toString() === i.idRol.toString()))
            }
            return arr;
        }, []);
        return (
            <div className="flex_full_row align_center">
                <span
                    className={
                        cx(
                            (listRoles && listRoles.length > 0)
                                ? 'barlow_regular_message tag hand'
                                : 'barlow_regular_message margin_left_12 flex_full_row hand',
                            {
                                c_bluish:
                                    node &&
                                    this.state.active &&
                                    this.state.active.some(
                                        (n) => parseInt(n.id, 10) === parseInt(node.id, 10),
                                    ),
                            }
                        )}
                    onMouseDown={function (e) {
                        e.stopPropagation();
                    }}
                    onClick={this.onClickNode.bind(null, node)}
                >
                    {node.name}
                </span>
                <div className="flex_auto_row wrap">
                    {listRoles &&
                        listRoles.map((t) => {
                            if (t) {
                                return (
                                    <Chip
                                        key={t.id}
                                        label={t.name}
                                        onDelete={this.handleDelete(node.id, t.id)}
                                        onMouseDown={function (e) {
                                            e.stopPropagation();
                                        }}
                                        className="margin_left_12 chip c_white bg_bluish"
                                    />
                                );
                            } else {
                                return <div />;
                            }
                        })}
                </div>
            </div>
        );
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx('collapse padding_top_12', collapsed ? 'caret-right' : 'caret-down')}
                onMouseDown={function (e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };


    render() {
        const { tree, openDialog, active, value } = this.state;
        const { disabled } = this.props;
        //console.log(value);
        return (
            <div className="width100">
                {!disabled &&
                    <Fab
                        className={'float_right z_index_dialog c_white ' + (active && active.length > 0 ? 'bg_bluish' : 'bg_disabled')}
                        aria-label="add"
                        disabled={!active || active.length === 0}
                        onClick={this.handleClickOpenDialog}
                    >
                        <AddIcon />
                    </Fab>
                }
                <Tree
                    paddingLeft={40}
                    tree={this.sortedTree(tree)}
                    orderBy={'name'}
                    noExpandName={true}
                    renderNode={this.renderNode(value)} // renderNode(node) return react element
                    renderCollapse={this.renderCollapse}
                    isNodeCollapsed={this.isNodeCollapsed}
                    disabled={disabled}
                />
                {openDialog && (
                    <DialogRoleSelect
                        {...this.props}
                        open
                        suggestions={this.props.suggestions}
                        onClose={this.handleChangeRoles}
                    />
                )}
            </div>
        );
    }
}

export default RoleTree;


// WEBPACK FOOTER //
// ./src/components/complex/communications/RoleTree.js